import { Loader2 } from "lucide-react";
import { useTranslation } from "react-i18next";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "../../../../../../shared/components/dialog/Dialog";
import { Button } from "../../../../../../shared/components/button/Button";

const DeleteDimensionDialog = ({
  dimension,
  onCancel,
  isDeleting,
  onDeleteHandler,
}) => {
  const { t } = useTranslation();

  return (
    <Dialog open={dimension !== null}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>
            {t("datasetsCentre.datasets.dimensions.deleteTitle")}
          </DialogTitle>
          <DialogDescription>
            {t("datasetsCentre.datasets.dimensions.deleteMessage")}
            {dimension && (
              <div className="mt-2 p-2 bg-muted rounded text-sm">
                <strong>{t("datasetsCentre.common.code")}:</strong>{" "}
                {dimension.code}
              </div>
            )}
          </DialogDescription>
        </DialogHeader>
        <DialogFooter>
          <Button variant="outline" onClick={onCancel} disabled={isDeleting}>
            {t("datasetsCentre.common.cancel")}
          </Button>
          <Button
            variant="destructive"
            onClick={() => dimension && onDeleteHandler(dimension.id)}
            disabled={isDeleting}
          >
            {isDeleting ? (
              <>
                <Loader2 className="w-4 h-4 mr-2 animate-spin" />
                {t("datasetsCentre.common.deleting")}
              </>
            ) : (
              t("datasetsCentre.datasets.dimensions.deleteTitle")
            )}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default DeleteDimensionDialog;
